import { Component, Inject } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { PipesModule } from "../../pipes/pipes.module";
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-allow-user-profile-field',
  standalone: true,
  imports: [CheckboxModule, CommonModule, FormsModule, ButtonModule, PipesModule],
  templateUrl: './allow-user-profile-field.component.html',
})
export class AllowUserProfileFieldComponent {
  
  value!: boolean;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public toast: ToastService
  ) {}

  onSave() {
    if(this.value === undefined) {
      this.toast.showError(`Field Selection is Required`);
      return;
    }
    this.ref.close(this.value);
  }

  onCancel() {
    this.ref.close();
  }
}
